import { render, staticRenderFns } from "./SNEmpower.vue?vue&type=template&id=1147af01&scoped=true"
import script from "./SNEmpower.vue?vue&type=script&lang=js"
export * from "./SNEmpower.vue?vue&type=script&lang=js"
import style0 from "./SNEmpower.vue?vue&type=style&index=0&id=1147af01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1147af01",
  null
  
)

export default component.exports